export default __webpack_public_path__ + "static/media/download.0314ca7b.svg";